import {DomainStore, serializeModel} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {MFAUser} from 'main/stores/authy';
import {api} from 'shared/core';
import {endpoints, types, auth} from 'main/tools';
import {redirect} from 'shared/tools';
import {RecoveryCode} from 'shared/stores/recovery_codes';

class MFASetupContainerState {
  store = new DomainStore();

  STATES = {
    optionSelection: 0,
    userCreation: 1,
    verification: 2,
    recoveryCode: 3
  };

  mfaUser = new MFAUser();
  errors = {};
  currentState = 0;
  qrCode;
  redirectUrl;
  recoveryCode = new RecoveryCode();

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  goToOptionSelection() {
    this.currentState = this.STATES.optionSelection;
    this.mfaUser.update({mfaType: null});
  }

  async goToSetupForType() {
    if (this.mfaUser.mfaType === 'sms') {
      this.goToUserCreation();
    } else {
      await this.setupAuthenticator();
    }
  }

  goToUserCreation() {
    this.currentState = this.STATES.userCreation;
  }

  goToVerification() {
    this.currentState = this.STATES.verification;
  }

  async setupAuthenticator() {
    const {model, errors} = await this.store.post(
      endpoints.MFA.SETUP_AUTHENTICATOR,
      types.AUTHENTICATION_RESULT,
      this.mfaUser
    );

    this.errors = errors;

    if (model) {
      this.mfaUser.merge(model);
      this.goToVerification();
    }
  }

  async goToRecoveryCode(response) {
    await this.store.post(endpoints.RECOVERY_CODES, types.RECOVERY_CODE);

    this.recoveryCode.merge(
      this.store._getSingle(types.RECOVERY_CODE)
    );
    this.currentState = this.STATES.recoveryCode;
    this.redirectUrl = response.headers.location;
  }

  async setupSMS() {
    const {model, errors} = await this.store.post(
      endpoints.MFA.SETUP_SMS,
      types.AUTHENTICATION_RESULT,
      this.mfaUser
    );

    this.errors = errors;

    if (model) {
      this.mfaUser.merge(model);
      this.goToVerification();
    }
  }

  async verifyPhoneNumber() {
    const payload = serializeModel(this.mfaUser);
    try {
      const response = await api.post(
        endpoints.MFA.VERIFY_MFA_METHOD,
        payload
      );
      this.errors = {};
      await this.goToRecoveryCode(response);
    } catch (e) {
      this.errors = e.formErrors;
    }
  }

  async finish() {
    let url = '/';

    if (this.redirectUrl) {
      url = this.redirectUrl;
    }

    await redirect(url);
  }

  async logout() {
    const response = await api.delete(endpoints.SESSIONS.new);
    this.redirectUrl = response.headers.location;

    await this.finish();
  }

  get companyMfaEnabled() {
    return auth.company.mfaSmsEnabled || auth.company.mfaAuthenticatorEnabled;
  }

  get smsEnabled() {
    return auth.company.mfaSmsEnabled;
  }

  get authenticatorEnabled() {
    return auth.company.mfaAuthenticatorEnabled;
  }
}

export default MFASetupContainerState;
